import * as React from 'react';
import AmountInput from './AmountInput';
import '../css/addPayment.sass';
import LinkButton from './LinkButton';
import { RulesMessages } from '../utils/validator';

interface OtherAmountProps {
  otherAmountLabel?: string;
  confirmLabel?: string;
  amountLabel?: string;
  maxAmount?: number;
  minAmount?: number;
  rulesMessages?: RulesMessages;
  displayDetails?: boolean;
  onConfirm: (paymentAmount: number) => void;
}
interface OtherAmountState {
  otherAmount?: number;
}

export default function OtherAmount(props: OtherAmountProps) {
  const {
    otherAmountLabel = 'Other Amount',
    confirmLabel = 'Confirm',
    amountLabel = 'Amount',
    maxAmount = 500
  } = props;

  const [state, setState] = React.useState<OtherAmountState>({});

  return (
    <div className="addPayment">
      {props.displayDetails && (
        <>
          <div>{otherAmountLabel}</div>
          <div>
            {state.otherAmount !== undefined ? (
              <span className="bankDetails">{`$${state.otherAmount.toFixed(
                2
              )}`}</span>
            ) : (
              <>&nbsp;</>
            )}
          </div>
          <div className="hr">&nbsp;</div>
        </>
      )}
      <div>
        <AmountInput
          name="otheramountinput"
          id="otheramountinput"
          focus
          label={amountLabel}
          rulesMessages={props.rulesMessages}
          minValue={props.minAmount}
          onChange={(e: any, amount: number) => {
            setState({ otherAmount: amount });
          }}
          onError={() => setState({ otherAmount: undefined })}
          maxValue={maxAmount}
        />
      </div>
      <div style={{ textAlign: 'right' }}>
        <LinkButton
          name="confirmothamt"
          id="confirmothamt"
          smol
          disabled={state.otherAmount === undefined}
          onClick={() => {
            if (state.otherAmount !== null && state.otherAmount !== undefined) {
              props.onConfirm(state.otherAmount);
            }
          }}
        >
          {confirmLabel}
        </LinkButton>
      </div>
    </div>
  );
}
